'use client'

import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import type { ProcessedTheme } from '../ProcessedEntry/DomainEntry/processedTypes'
import { watchClasses } from '../ProcessedEntry/DomainEntry/processedTypes'

type EditableField = 'sender' | 'created_at' | 'message_subject' | 'message_content'

// Same "Conteúdo" editable fields CasosView offers before accepting a raw
// entry, as a standalone widget. Controlled/uncontrolled split matches
// AssignFieldsWidget: the caller owns the actual values (usually a
// fieldOverrides-over-raw merge) and decides when/whether an edit gets
// synced to the backend — this widget only ever reports the field+value
// that changed.
export function EditInputWidget({
  theme,
  postType,
  sender,
  createdAt,
  messageSubject,
  messageContent,
  onChange,
  hint,
}: {
  theme: ProcessedTheme
  /** 'call' entries have no subject/content fields worth editing here. */
  postType?: string | null
  sender?: string | null
  createdAt?: string | null
  messageSubject?: string | null
  messageContent?: string | null
  onChange: (field: EditableField, value: string) => void
  hint?: string
}) {
  const c = watchClasses(theme)

  return (
    <div className="space-y-3">
      <div>
        <div className={`mb-1 text-[11px] font-semibold ${c.label}`}>Sender</div>
        <Input className={c.input} value={sender ?? ''} onChange={(e) => onChange('sender', e.target.value)} placeholder="Sender" />
      </div>
      <div>
        <div className={`mb-1 text-[11px] font-semibold ${c.label}`}>Created at</div>
        <Input className={c.input} value={createdAt ?? ''} onChange={(e) => onChange('created_at', e.target.value)} placeholder="created_at (ISO)" />
      </div>
      {postType !== 'call' && (
        <>
          <div>
            <div className={`mb-1 text-[11px] font-semibold ${c.label}`}>Subject</div>
            <Input className={c.input} value={messageSubject ?? ''} onChange={(e) => onChange('message_subject', e.target.value)} placeholder="Subject" />
          </div>
          <div>
            <div className={`mb-1 text-[11px] font-semibold ${c.label}`}>Content</div>
            <Textarea className={c.input} value={messageContent ?? ''} onChange={(e) => onChange('message_content', e.target.value)} placeholder="Message content" rows={5} />
          </div>
        </>
      )}
      {hint && <p className={`text-[10px] ${c.faint}`}>{hint}</p>}
    </div>
  )
}
